import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import Loader from "src/components/loader/loader";
import { useAppSelector } from "../../hooks/redux";
import styles from "../bulk-order/bulk-order.module.scss";
import BulkOrder from "../bulk-order/bulk-order";
import Modal from "react-modal";
const BulkOrderForm = () => {
    const [bulkOrderModal, setBulkOrderModal] = useState(false);
    const toggleBulkOrderModal = () => setBulkOrderModal((bulkOrderModal) => !bulkOrderModal);
    const bulkOrderPlacement = useAppSelector((state) => {
        return state.modals.bulkOrderPlacement;
    });
    return (_jsx(_Fragment, { children: bulkOrderPlacement != undefined && (_jsx(Modal, Object.assign({ isOpen: bulkOrderPlacement !== undefined || bulkOrderModal, onRequestClose: toggleBulkOrderModal, className: styles.myCommonModal, overlayClassName: styles.myCommonOverlay }, { children: _jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(BulkOrder, { BulkOrderData: bulkOrderPlacement }) })) }))) }));
};
export default BulkOrderForm;
